export default __webpack_public_path__ + "static/media/cartes.2324ea1a.svg";